import React, { useState, useRef, useEffect } from 'react';
import './ContactChatbot.css';
import { FaRobot, FaTimes, FaPaperPlane } from 'react-icons/fa';

const ContactChatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([
        { text: "Hello! Welcome to TrustYouDoctor. How can I help you today?", sender: 'bot' }
    ]);
    const [inputValue, setInputValue] = useState('');
    const [step, setStep] = useState(0);
    const [userData, setUserData] = useState({ email: '', phone: '' });
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSendMessage = (e) => {
        e.preventDefault();
        if (!inputValue.trim()) return;

        const userMessage = { text: inputValue, sender: 'user' };
        setMessages(prev => [...prev, userMessage]);
        setInputValue('');

        // Process user input based on current step
        setTimeout(() => {
            processUserInput(inputValue);
        }, 500);
    };

    const processUserInput = (input) => {
        let botResponse = '';
        let newStep = step;

        switch (step) {
            case 0:
                // Initial greeting - ask for email
                botResponse = "Great! To assist you better, could you please provide your email ID?";
                newStep = 1;
                break;
            case 1:
                // Collect email
                if (validateEmail(input)) {
                    setUserData(prev => ({ ...prev, email: input }));
                    botResponse = "Thank you! Now, could you please share your phone number?";
                    newStep = 2;
                } else {
                    botResponse = "Please enter a valid email address. For example: user@example.com";
                }
                break;
            case 2:
                // Collect phone
                if (validatePhone(input)) {
                    setUserData(prev => ({ ...prev, phone: input }));
                    botResponse = `Perfect! I've recorded your details:\n\nEmail: ${userData.email}\nPhone: ${input}\n\nOur team will contact you shortly. Is there anything else you'd like to know?`;
                    newStep = 3;
                } else {
                    botResponse = "Please enter a valid phone number. For example: +91 9922514719";
                }
                break;
            case 3:
                // Additional questions
                botResponse = "Thank you for contacting TrustYouDoctor! If you have any more questions, feel free to ask. You can also reach us at contact@trustyoudoctor.com or call +91 9922514719";
                newStep = 3;
                break;
            default:
                botResponse = "How can I help you?";
        }

        setStep(newStep);
        setMessages(prev => [...prev, { text: botResponse, sender: 'bot' }]);
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validatePhone = (phone) => {
        const re = /^[\d\s\-\+\(\)]{10,}$/;
        return re.test(phone.replace(/\s/g, ''));
    };

    const toggleChatbot = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <button 
                className={`chatbot-toggle ${isOpen ? 'hidden' : ''}`}
                onClick={toggleChatbot}
            >
                <FaRobot className="chatbot-icon" />
                <span>Chat with us</span>
            </button>

            <div className={`chatbot-container ${isOpen ? 'open' : ''}`}>
                <div className="chatbot-header">
                    <div className="chatbot-title">
                        <FaRobot className="title-icon" />
                        <span>TrustYouDoctor Support</span>
                    </div>
                    <button className="close-button" onClick={toggleChatbot}>
                        <FaTimes />
                    </button>
                </div>

                <div className="chatbot-messages">
                    {messages.map((message, index) => (
                        <div key={index} className={`message ${message.sender}`}>
                            {message.text.split('\n').map((line, i) => (
                                <p key={i}>{line}</p>
                            ))}
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>

                <form className="chatbot-input" onSubmit={handleSendMessage}>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Type your message..."
                        disabled={step === 3}
                    />
                    <button type="submit" disabled={step === 3}>
                        <FaPaperPlane />
                    </button>
                </form>
            </div>
        </>
    );
};

export default ContactChatbot;
